import { SiteUrls } from '@tableau/shared-urls';
import { CheckBoxWidget, TextLinkWidget } from '@tableau/widgets';
import { BodyCell, DataGrid } from '@tableau/widgets-datagrid';
import * as React from 'react';

import { StyledCellFormatter } from '~src/app/spaces/ListView/StyledCellWrapper';
import { Messages } from '~src/codegen/Localize';
import { imgPath } from '~src/common/utilities/ImgUrl';
import { classes,cssClass, textEllipsis } from '~src/style';
import { FlowWithRunPermission } from '~src/ts/ServerApi/requests/GetFlowsWithRunPermissionsRequest';

const rootClass: string = 'SelectFlowCell';

const lineHeight: string = '20px';

const SelectFlowCellWrapper = cssClass(rootClass, 'Wrapper', {
  display: 'flex',
  flexDirection: 'row',
  paddingTop: '10px',
});

const CheckboxWrapper = cssClass(rootClass, 'CheckboxWrapper', {
  display: 'flex',
  marginLeft: '-12px',
  paddingRight: '12px'
});

const ContentItem = cssClass(rootClass, 'Item', textEllipsis, {
  height: lineHeight,
  lineHeight: lineHeight,
});

const ItemIcon = cssClass(rootClass, 'ItemIcon', {
  paddingRight: '6px',
  height: lineHeight,
  lineHeight: lineHeight,
});

const TextWrapper = cssClass(rootClass, 'TextWrapper', {
  display: 'flex',
  flexDirection: 'column',
});

const InnerTextWrapper = cssClass(rootClass, 'InnerTextWrapper', {
  display: 'flex',
  flexDirection: 'row',
});

const Disabled = cssClass(rootClass, 'Disabled', {
  opacity: 0.6,
  pointerEvents: 'none',
});

const itemLinkStyle: React.CSSProperties = {
  height: lineHeight,
  lineHeight: lineHeight,
  marginTop: '-1px',
  paddingLeft: '3px'
};

const flowIconImgPath = imgPath('spaces_small_flow.svg');

const handleCheckboxClick = (e: React.SyntheticEvent<HTMLInputElement, Event>) => {
  // let handleCellClick handle click events
  e.preventDefault();
};

const handleLinkClick = (e: React.SyntheticEvent<HTMLAnchorElement, Event>) => {
  // navigate to link but don't let handleCellClick get the event
  e.stopPropagation();
};

export function SelectFlowCell(isSelected: (id: string) => boolean, onItemSelectionToggle: (row: DataGrid.Row) => void, siteUrls: SiteUrls): React.StatelessComponent<BodyCell.Props> {
  return StyledCellFormatter(
    function SelectFlowCell(props: BodyCell.Props) {
      const flow: FlowWithRunPermission = props.row.data as FlowWithRunPermission;

      const handleCellClick = (e: React.SyntheticEvent<HTMLDivElement, Event>) => {
        onItemSelectionToggle(props.row);
        e.preventDefault();
        e.stopPropagation();
      };

      return (
        /* eslint-disable jsx-a11y/no-static-element-interactions */
        /* eslint-disable jsx-a11y/click-events-have-key-events */
        <div
          onClick={handleCellClick}
          key={flow.id}
          className={classes(SelectFlowCellWrapper, !flow.userHasRunPermissions && Disabled)}
          data-tb-test-id={'SelectFlowCellTestId'}
        >
          <div className={CheckboxWrapper}>
            <CheckBoxWidget
              checked={isSelected(flow.id)}
              handleChange={() => onItemSelectionToggle(props.row)}
              testId={'SelectFlowCellCheckboxTestId'}
              removeLeftMargin={true}
              onClick={handleCheckboxClick}
              disabled={!flow.userHasRunPermissions}
            />
          </div>
          <img src={flowIconImgPath} className={ItemIcon} alt={Messages.flow()} />
          <div className={TextWrapper}>
            <div className={InnerTextWrapper}>
              <div className={ContentItem} title={flow.name}>{Messages.linkedTasksRunFlowSentenceCasing()}</div>
              <TextLinkWidget
                href={siteUrls.flowOverviewUrl(flow.id)}
                target={'_blank'}
                testId={'SelectFlowCellLinkTestId'}
                title={flow.name}
                style={itemLinkStyle}
                onClick={handleLinkClick}
              >
                {flow.name}
              </TextLinkWidget>
            </div>
          </div>
        </div>
      );
    }
  );
}
